{
  "& next": " & next",
  "A réception de la facture": "A réception de la facture",
  "Accept": "Accept",
  "Accept document": "Accept document",
  "Accept documents": "Accept documents",
  "Accepted": "Accepted",
  "ACCEPTED": "accepted",
  "Accepted format: .csv, .xls and .xlsx;": "Accepted format: .csv, .xls and .xlsx;",
  "Accepted payment methods": "Accepted payment methods",
  "Accepted successfully": "Accepted successfully",
  "accepted_format": "Accepted format: .csv, .xls and .xlsx;",
  "Account": "Account",
  "Account Number": "Account Number",
  "Account prefix": "Account prefix",
  "Accountant": "Accountant",
  "Accountant Transfer": "Accountant Transfer",
  "Accounting": "Accounting",
  "Accounting firm": "Accounting firm",
  "Accounting Firm": "Accounting Firm",
  "Accounting information": "Accounting information",
  "Accounting setup": "Accounting setup",
  "Accounts": "Accounts",
  "action": "action",
  "Action": "Action",
  "Actions": "Actions",
  "Active": "Active",
  "Activity": "Activity",
  "Add": "Add",
  "Add a bank account and mark it as main, then create a SEPA mandate.": "Add a bank account and mark it as main, then create a SEPA mandate.",
  "ADD A DOCUMENT (PDF - 2 MB)": "ADD A DOCUMENT (PDF - 2 MB)",
  "Add a note or legal mention...": "Add a note or legal mention...",
  "Add account": "Add account",
  "Add address": "Add address",
  "Add bank": "Add bank",
  "Add bank account": "Add bank account",
  "Add category": "Add category",
  "Add client": "Add client",
  "Add comment": "Add comment",
  "Add contact": "Add contact",
  "Add currency": "Add currency",
  "Add date": "Add date",
  "Add delivery": "Add delivery",
  "Add email": "Add email",
  "Add end line": "Add end line",
  "Add end page": "Add end page",
  "Add livraison": "Add livraison",
  "Add new attachment": "Add new attachment",
  "Add payment": "Add payment",
  "Add payment in advance": "Add payment in advance",
  "Add periodic billing": "Add periodic billing",
  "Add phone": "Add phone",
  "Add return": "Add return",
  "Add sale account": "Add sale account",
  "Add sale vat": "Add sale vat",
  "Add sepa order": "Add sepa order",
  "Add subtotal": "Add subtotal",
  "Add template": "Add template",
  "Add title": "Add title",
  "Add VAT": "Add VAT",
  "Add vat type": "Add vat type",
  "Additional address": "Additional address",
  "Address": "Address",
  "Address Nr": "Address Nr",
  "Advance payment issued counterpart": "Advance payment issued counterpart",
  "Advance payment issued tva counterpart": "Advance payment issued tva counterpart",
  "Advance payment percentage": "Advance payment percentage",
  "Advance payment received counterpart": "Advance payment received counterpart",
  "Advance payment received tva counterpart": "Advance payment received tva counterpart",
  "All": "All",
  "All column headers must be in French exactly as shown above": "All column headers must be in French exactly as shown above",
  "All done": "All done",
  "amount": "amount",
  "Amount": "Amount",
  "Amount should less or equal of document amount.": "Amount should less or equal of document amount.",
  "Amount to be deducted": "Amount to be deducted",
  "An error occurred, please refresh the page or click the button below": "An error occurred, please refresh the page or click the button below",
  "An unexpected error occurred processing your request, please try again later": "An unexpected error occurred processing your request, please try again later.",
  "An unexpected error occurred processing your request, please try again later.": "",
  "Analytical type": "Analytical type",
  "ANNULLED": "annulled",
  "Anull": "Anull",
  "Anull document": "Anull document",
  "Anulled": "Anulled",
  "Anuller": "Anuller",
  "Archive": "Archive",
  "Archive payment date limit": "Archive payment date limit",
  "Archive product": "Archive product",
  "Archived at": "Archived at",
  "Are you sure about delete this account?": "Are you sure about delete this account?",
  "Are you sure about delete this address?": "Are you sure about delete this address?",
  "Are you sure about delete this bank account?": "Are you sure about delete this bank account?",
  "Are you sure about delete this category?": "Are you sure about delete this category?",
  "Are you sure about delete this client?": "Are you sure about delete this client?",
  "Are you sure about delete this comment?": "Are you sure about delete this comment?",
  "Are you sure about delete this contact?": "Are you sure you want to delete this contact?",
  "Are you sure about delete this email?": "Are you sure about delete this email?",
  "Are you sure about delete this payment?": "Are you sure about delete this payment?",
  "Are you sure about delete this phone?": "Are you sure about delete this phone?",
  "Are you sure about delete this product?": "Are you sure about delete this product?",
  "Are you sure about delete this sale account?": "Are you sure about delete this sale account?",
  "Are you sure about delete this sale vat?": "Are you sure about delete this sale vat?",
  "Are you sure about delete this template?": "Are you sure about delete this template?",
  "Are you sure about delete this vat?": "Are you sure about delete this vat?",
  "Are you sure you want to accept this document?": "Are you sure you want to accept this document?",
  "Are you sure you want to anull this document?": "Are you sure you want to anull this document?",
  "Are you sure you want to archive this deadline ?": "Are you sure you want to archive this deadline ?",
  "Are you sure you want to archive this product ?": "Are you sure you want to archive this product ?",
  "Are you sure you want to delete this attachment?": "Are you sure you want to delete this attachment?",
  "Are you sure you want to delete this billing ?": "Are you sure you want to delete this billing ?",
  "Are you sure you want to delete this bulk?": "Are you sure you want to delete this bulk?",
  "Are you sure you want to delete this delivery?": "Are you sure you want to delete this delivery?",
  "Are you sure you want to delete this document?": "Are you sure you want to delete this document?",
  "Are you sure you want to leave without saving the value?": "Are you sure you want to leave without saving the value?",
  "Are you sure you want to move the bulk to Neoscan Expert?": "Are you sure you want to move the bulk to Neoscan Expert?",
  "Are you sure you want to move the bulk to SSI?": "Are you sure you want to move the bulk to SSI?",
  "Are you sure you want to produce this document?": "Are you sure you want to produce this document?",
  "Are you sure you want to reactivate this deadline ?": "Are you sure you want to reactivate this deadline ?",
  "Are you sure you want to reactivate this product ?": "Are you sure you want to reactivate this product ?",
  "Are you sure you want to refuse this document?": "Are you sure you want to refuse this document?",
  "Are you sure you want to resume this periodic payment ?": "Are you sure you want to resume this periodic payment ?",
  "Are you sure you want to stop this billing ?": "Are you sure you want to stop this billing ?",
  "Are you sure you want to validate this document?": "Are you sure you want to validate this document?",
  "Are you sure, that you want to delete?": "Are you sure, that you want to delete?",
  "Assets": "Assets",
  "Assets format": "Assets format",
  "Assign saved with success": "Assign saved with success.",
  "ATC": "ATC",
  "Attach the document in PDF": "Attach the document in PDF",
  "Attach the documents as an attachment to the email": "Attach the documents as an attachment to the email",
  "Attachment": "Attachment",
  "Attachment deleted": "Attachment deleted",
  "Attachments": "Attachments",
  "Attachments will always be available on the client interface, accessible from the email.": "Attachments will always be available on the client interface, accessible from the email.",
  "Auto exported": "Auto exported",
  "Automatic reminder": "Automatic reminder",
  "Automations": "Automations",
  "Available units": "Available units",
  "Avoid numbering without separators such as": "Avoid numbering without separators such as",
  "Back": "Back",
  "Background": "Background",
  "Balance": "Balance",
  "Balance History": "Balance History",
  "Balance Overview": "Balance Overview",
  "Bank": "Bank",
  "Bank account": "Bank account",
  "Bank account for invoices": "Bank account for invoices",
  "Bank accounts": "Bank accounts",
  "Bank accountss": "Bank accountss",
  "Bank default": "Bank default",
  "Bank description": "Bank description",
  "Bank informations": "Bank informations",
  "Bank name": "Bank name",
  "Banks": "Banks",
  "Base Color": "Base Color",
  "Beginning day": "Beginning day",
  "Best-selling categories": "Best-selling categories",
  "Best-selling products": "Best-selling products",
  "BIC": "BIC",
  "BIC is missing": "BIC is missing",
  "Billing": "Billing",
  "BILLING": "BILLING",
  "Billing address": "Billing address",
  "Billing and payment": "Billing and payment",
  "Billing method": "Billing method",
  "Birthdate": "Birthdate",
  "Body": "Body",
  "Book": "Book",
  "Border": "Border",
  "Breakdown account - Europe": "Breakdown account - Europe",
  "Breakdown account - Export": "Breakdown account - Export",
  "BTQ": "BTQ",
  "BTQsssss": "BTQsssss",
  "budget": "budget",
  "Budget": "Budget",
  "BUDGET": "BUDGET",
  "budget accepted": "budget accepted",
  "Budget format": "Budget format",
  "Budget number": "Budget number",
  "Budget/Order reminder": "Budget/Order reminder",
  "Bulk deleted with success": "Bulk deleted with success.",
  "Bulks not validated": "Bulks not validated",
  "Bulks validated": "Bulks validated",
  "by": "by",
  "C. de vente - Europe": "C. de vente - Europe",
  "C. de vente - Export": "C. de vente - Export",
  "Cancel": "Cancel",
  "Cancel payment": "Cancel payment",
  "Cannot be accepted": "Cannot be accepted",
  "Cannot be produced": "Cannot be produced",
  "Cannot be validated": "Cannot be validated",
  "Cannot exceed {{max}}%": "Cannot exceed {{max}}%",
  "Cannot exceed the total amount": "Cannot exceed the total amount",
  "Capital": "Capital",
  "Catalog": "Catalog",
  "Categories": "Categories",
  "Category": "Category",
  "Category references must match existing categories in your system": "Category references must match existing categories in your system",
  "Change": "Change",
  "Change Bulk": "Change Bulk",
  "Change Delivery": "Change Delivery",
  "Choir": "Choir",
  "Choose template": "Choose template",
  "Chorus": "Chorus",
  "City": "City",
  "Clear selection": "Clear selection",
  "Client": "Client",
  "Client account": "Client account",
  "Client automatic numbering": "Client automatic numbering",
  "Client counterpart": "Client counterpart",
  "Client format": "Client format",
  "Client have documents associated.": "Client have documents associated.",
  "Client Information": "Client Information",
  "Client number": "Client number",
  "Client support": "Client support",
  "Client type": "Client type",
  "Client vat type": "Client vat type",
  "Client vat types": "Client vat types",
  "Clients": "Clients",
  "Close": "Close",
  "Code": "Code",
  "Code APE": "Code APE",
  "COFI": "COFI",
  "Collected": "Collected",
  "Collection sheet": "Collection sheet",
  "Comment": "Comment",
  "Comments": "Comments",
  "Company": "Company",
  "Company info": "Company info",
  "Company Information": "Company Information",
  "Company informations": "Company informations",
  "Company logo": "Company logo",
  "Company name": "Company name",
  "Company name or Client name": "Company name or Client name",
  "Company not found": "Company not found",
  "compensation mandatory on commercial invoices since 2013": "",
  "Compte client": "Compte client",
  "Configuration": "Configuration",
  "Configuration needed": "Configuration needed",
  "Configure client": "Configure client",
  "Confirm": "Confirm",
  "CONFIRMATION": "CONFIRMATION",
  "Contact": "Contact",
  "Contact details": "Contact details",
  "Contacts": "Contacts",
  "Counter Collective": "Counter Collective",
  "Counterpart": "Counterpart",
  "Counterpart allocation type": "Counterpart allocation type",
  "Counterpart code": "Counterpart code",
  "Counterpart product": "Counterpart product",
  "Counterpart VAT": "Counterpart VAT",
  "Counterparte VAT": "Counterparte VAT",
  "Country": "Country",
  "Create": "Create",
  "Create a budget": "Create a budget",
  "Create a delivery note": "Create a delivery note",
  "Create a return": "Create a return",
  "Create an invoice": "Create an invoice",
  "Create an order": "Create an order",
  "Create bank": "Create bank",
  "Create client": "Create client",
  "Create compte": "Create compte",
  "Create Document": "Create Document",
  "Create invoice": "Create invoice",
  "Create payment date": "Create payment date",
  "Create product": "Create product / service",
  "Create product / service": "Create product / service",
  "Created": "Created",
  "Credit": "Credit",
  "Currencies": "Currencies",
  "Currency": "Currency",
  "Currency Tracking": "Currency Tracking",
  "Current Balance": "Current Balance",
  "Custom template": "Custom template",
  "Customization": "Customization",
  "Customize your dashboard by toggling widgets on/off and reordering them by drag and drop.": "Customize your dashboard by toggling widgets on/off and reordering them by drag and drop.",
  "Cycle": "Cycle",
  "Cycles": "Cycles",
  "Dashboard": "Dashboard",
  "Dashboard Settings": "Dashboard Settings",
  "Date": "Date",
  "Date - Time": "Date - Time",
  "Date d'échéance": "Date d'échéance",
  "Date d'emmission": "Date d'emmission",
  "Date de fin": "Date de fin",
  "Date de signature du mandat": "Date de signature du mandat",
  "Date/Time": "Date/Time",
  "Day": "Day",
  "Days": "Days",
  "days_ago": "{{ diffDaysAgo }} days ago",
  "Deadline": "Deadline",
  "Deadline date": "Deadline date",
  "Deadline payment": "Deadline payment",
  "Debit": "Debit",
  "Debits": "Debits",
  "Decimal cases": "Decimal cases",
  "Decimal places": "Decimal places",
  "Decimal places for quantities": "Decimal places for quantities",
  "Decimal places for quantity": "Decimal places for quantity",
  "Decimals for the unit price": "Decimals for the unit price",
  "Decline": "Decline",
  "Default bank account": "Default bank account",
  "Default clients counterparts": "Default clients counterparts",
  "Default Counterpart": "Default Counterpart",
  "Default Counterparts": "Default Counterparts",
  "Default price type (HT/TTC)": "Default price type (HT/TTC)",
  "Default providers counterparts": "Default providers counterparts",
  "default_price_type_HT": "HT : This option allows you to invoice classically in HT. The calculation will be done by adding the VAT. The price in the Products file will be given in HT (it will be possible to modify it punctually on the article).",
  "default_price_type_TTC": "TTC : This option will allow you to invoice in TTC. The price in the Products file will be given in VAT. The software will recalculate the price before tax according to the VAT rate.",
  "Delete": "Delete",
  "Delete account": "Delete account",
  "Delete address": "Delete address",
  "Delete bank account": "Delete bank account",
  "Delete billing": "Delete billing",
  "Delete Bulk": "Delete Bulk",
  "Delete category": "Delete category",
  "Delete client": "Delete client",
  "Delete comment": "Delete comment",
  "Delete contact": "Delete contact",
  "Delete document": "Delete document",
  "Delete documents": "Delete documents",
  "Delete email": "Delete email",
  "Delete image": "Delete image",
  "Delete payment": "Delete payment",
  "Delete phone": "Delete phone",
  "Delete product": "Delete product / service",
  "Delete sale account": "Delete sale account",
  "Delete sale vat": "Delete sale vat",
  "Delete template": "Delete template",
  "Delete vat": "Delete vat",
  "Deleted Successfully": "Deleted Successfully",
  "Deliveries": "Deliveries",
  "Deliveries not validated": "Deliveries not validated",
  "Deliveries validated": "Deliveries validated",
  "delivery": "Delivery",
  "Delivery": "Delivery",
  "DELIVERY": "DELIVERY",
  "Delivery address": "Delivery address",
  "Delivery address details": "Delivery address details",
  "Delivery cost counterpart": "Delivery cost counterpart",
  "Delivery deleted with success": "Delivery deleted with success.",
  "Delivery form": "Delivery form",
  "Delivery format": "Delivery format",
  "delivery note": "delivery note",
  "Delivery number": "Delivery number",
  "DELIVERY_FORM": "Delivery form",
  "Description": "Description",
  "Description on document": "Description on document",
  "Deselect all": "Deselect all",
  "Designation": "Designation",
  "Désignation": "Désignation",
  "Devise": "Devise",
  "Disc": "Disc",
  "Discard and continue": "Discard and continue",
  "Discount": "Discount",
  "DISCOUNT": "DISCOUNT",
  "Discount comment": "",
  "Display": "Display",
  "Display documents": "Display documents",
  "Display format": "Display format",
  "Display name": "Display name",
  "Display the line signature and company stamp on the PDF": "Display the line signature and company stamp on the PDF",
  "Do export": "Do export",
  "Do you want to validate?": "Do you want to validate?",
  "Document": "Document",
  "Document creation": "Document creation",
  "Document formats": "Document formats",
  "Document modification": "Document modification",
  "Document name": "Document name",
  "Document Name": "Document Name",
  "Document template": "Document template",
  "Document types": "Document types",
  "Document(s)": "Document(s)",
  "document(s) selected": "document(s) selected",
  "documents": "documents",
  "Documents": "Documents",
  "Documents below could not be validated. Please try to produce manually.": "Documents below could not be validated. Please try to produce manually.",
  "Documents below could not be validated. Please try to validate manually.": "Documents below could not be validated. Please try to validate manually.",
  "documents selected": "documents selected",
  "documentsReadyForExport": "documents ready for export",
  "Download": "Download",
  "Download the model file for a template with all available columns": "Download the model file for a template with all available columns",
  "DRAFTED": "drafted",
  "Draw your signature below": "Draw your signature below",
  "Dunning invoice Level 1": "Dunning invoice Level 1",
  "Dunning invoice Level 2": "Dunning invoice Level 2",
  "Dunning invoice Level 3": "Dunning invoice Level 3",
  "Dunning reminders for unpaid invoices": "Dunning reminders for unpaid invoices",
  "DUPLICATA": "DUPLICATA",
  "Duplicate": "Duplicate",
  "Duplicate document preview": "Duplicate document preview",
  "Duplicate documents": "Duplicate documents",
  "Duplicated Successfully": "Duplicated Successfully",
  "Duration of validity (days)": "Duration of validity (days)",
  "Duration of validity in days (Budget and Orders)": "Duration of validity in days (Budget and Orders)",
  "E-MAIL": "E-MAIL",
  "early payment discount terms": "",
  "Echéance": "Echéance",
  "Échéance": "Échéance",
  "Échéance par défaut": "Échéance par défaut",
  "Edit": "Edit",
  "Edit address": "Edit address",
  "Edit bank": "Edit bank",
  "Edit bank account": "Edit bank account",
  "Edit category": "Edit category",
  "Edit Client": "Edit Client",
  "Edit comment": "Edit comment",
  "Edit compte": "Edit compte",
  "Edit contact": "Edit contact",
  "Edit email": "Edit email",
  "Edit export configuration": "Edit export configuration",
  "Edit phone": "Edit phone",
  "Edit settings": "Edit settings",
  "Edit Settings": "Edit Settings",
  "Electronic address PA": "Electronic address PA",
  "Electronic address used to send invoices to the public platform": "Electronic address used to send invoices to the public platform",
  "Email": "Email",
  "Email address": "Email address",
  "Email attachments": "Email attachments",
  "Email configuration keywords": "Email configuration keywords",
  "Email settings": "Email settings",
  "Email template for budget documents": "Email template for budget documents",
  "Email template for grouped document reminders": "Email template for grouped document reminders",
  "Email template for invoices": "Email template for invoices",
  "Email template for payment acknowledgements": "Email template for payment acknowledgements",
  "Email template for sale orders and reminders": "Email template for sale orders and reminders",
  "Emails": "Emails",
  "Emails sent": "Emails sent",
  "Emails status": "Emails status",
  "Empty cells are allowed for non-required fields": "Empty cells are allowed for non-required fields",
  "Enable features": "Enable features",
  "End": "End",
  "End date": "End date",
  "End line": "End line",
  "End page": "End page",
  "English": "English",
  "Enter product name": "Enter product name",
  "Enter reference": "Enter reference",
  "ENTREPRISE": "Entreprise",
  "Error": "Error",
  "Error code": "Error code",
  "Error loading options": "Error loading options",
  "Error opening document, please contact administrator": "Error opening document, please contact administrator",
  "Errors": "Errors",
  "Escompte": "Escompte",
  "Estimated amount": "Estimated amount",
  "Etat": "Etat",
  "Eu sell counterpart": "Eu sell counterpart",
  "Evolution of the business": "Evolution of the business",
  "Example": "Example",
  "Examples": "Examples",
  "expired budgets": "expired budgets",
  "Export": "Export",
  "Export all documents": "Export all documents",
  "Export all documents to Excel": "Export all documents to Excel",
  "Export configuration": "Export configuration",
  "Export error": "Export error",
  "Export Errors": "Export Errors",
  "Export message": "Export message",
  "Export selected documents": "Export selected documents",
  "Export selected documents to Excel": "Export selected documents to Excel",
  "Exported": "Exported",
  "Exports": "Exports",
  "Exports history": "Exports history",
  "Extra information": "Extra information",
  "FACT-AAMM-XXXX will give a number for the fourteenth invoice issued on 7 January 2023 - FACT- 2301-0014": "FACT-AAMM-XXXX will give a number for the fourteenth invoice issued on 7 January 2023 - FACT- 2301-0014",
  "Fax": "Fax",
  "Features": "Features",
  "Fiche": "Fiche",
  "Fichier PDF du mandat": "Fichier PDF du mandat",
  "File": "File",
  "File download": "File download",
  "Filters": "Filters",
  "Finish": "Finish",
  "First generation": "First generation",
  "First generation is the first billing date for this invoice which will be generated periodically according to the defined Frequency. It also defines the anniversary day of the due dates. For a monthly frequency and a first generation date of 04/09, the invoices will be generated on 04/09 then 04/10, then 04/11...)": "First generation is the first billing date for this invoice which will be generated periodically according to the defined Frequency. It also defines the anniversary day of the due dates. For a monthly frequency and a first generation date of 04/09, the invoices will be generated on 04/09 then 04/10, then 04/11...)",
  "Fixed recovery fee": "Fixed recovery fee",
  "Follow ups": "Follow ups",
  "Fonts": "Fonts",
  "Footer": "Footer",
  "for": "for",
  "For a better experience, please complete the configuration in the Address and Bank accounts tabs.": "For a better experience, please complete the configuration in the Address and Bank accounts tabs.",
  "For a better experience, please complete the configuration in the Address and Payments tabs.": "For a better experience, please complete the configuration in the Address and Payments tabs.",
  "For a better experience, please complete the configuration in the Bank accounts tabs.": "For a better experience, please complete the configuration in the Bank accounts tabs.",
  "for an amount of": "for an amount of",
  "For an amount of": "For an amount of",
  "For example, FACT-AAMM-XXXX will give a number for the fourteenth invoice issued on 7 January 2023 - FACT- 2301-0014": "For example, FACT-AAMM-XXXX will give a number for the fourteenth invoice issued on 7 January 2023 - FACT- 2301-0014",
  "For example, FACT-AAMM-XXXXN will give a number for the fourteenth invoice issued on 7 January 2023 - FACT- 2301-000014": "For example, FACT-AAMM-XXXXN will give a number for the fourteenth invoice issued on 7 January 2023 - FACT- 2301-000014",
  "For fields with options (Type de client, Type TVA client, Forme juridique), use the exact codes shown": "For fields with options (Type de client, Type TVA client, Forme juridique), use the exact codes shown",
  "For fields with options (Type de client, Type TVA client, Forme juridique), you must use the exact codes shown (e.g., 'en', 'LOC', 'SARL'). The codes are case-sensitive.": "For fields with options (Type de client, Type TVA client, Forme juridique), you must use the exact codes shown (e.g., 'en', 'LOC', 'SARL'). The codes are case-sensitive.",
  "Format & Units": "Format & Units",
  "Format & Units ": "Format & Units ",
  "Format for budget numbering": "Format for budget numbering",
  "Format for client numbering": "Format for client numbering",
  "Format for delivery numbering": "Format for delivery numbering",
  "Format for invoices numbering": "Format for invoices numbering",
  "Format for orders numbering": "Format for orders numbering",
  "Format for payment in advance numbering": "Format for payment in advance numbering",
  "Format for receipt numbering": "Format for receipt numbering",
  "Format for return numbering": "Format for return numbering",
  "Formats": "Formats",
  "Fournisseur": "Fournisseur",
  "France": "France",
  "French": "French",
  "Frequency": "Frequency",
  "General": "General",
  "General accounts length": "General accounts length",
  "General information": "General information",
  "Generation frequency and occurrences": "Generation frequency and occurrences",
  "Generation mode": "Generation mode",
  "Get started": "Get started",
  "Get Started": "Get Started",
  "Go back": "Go back",
  "Go to company settings": "Go to company settings",
  "Go to Dashboard": "Go to Dashboard",
  "Go to Home": "Go to Home",
  "Grid": "Grid",
  "Group": "Group",
  "Group dunning notices by customer": "Group dunning notices by customer",
  "has changed to the status": "has changed to the status",
  "Head office information": "Head office information",
  "Header": "Header",
  "HelpDesk": "HelpDesk",
  "Helpful information": "Helpful information",
  "Hide phones & emails": "Hide phones & emails",
  "History": "History",
  "Home": "Home",
  "How to define your numbering formats?": "How to define your numbering formats?",
  "HT": "HT",
  "HT : This option allows you to invoice classically in HT. The calculation will be done by adding the VAT. The price in the Products file will be given in HT (it will be possible to modify it punctually on the article).": "HT : This option allows you to invoice classically in HT. The calculation will be done by adding the VAT. The price in the Products file will be given in HT (it will be possible to modify it punctually on the article).",
  "IBAN": "IBAN",
  "IBAN is missing": "IBAN is missing",
  "Id": "Id",
  "Identity": "Identity",
  "IDs": "IDs",
  "If a main address already exists and you create a new main address, the old one will be changed to type Other.": "If a main address already exists and you create a new main address, the old one will be changed to type Other.",
  "If enabled, automatic reminders will be sent to clients for unpaid invoices.": "If enabled, automatic reminders will be sent to clients for unpaid invoices.",
  "If enabled, client numbering will be automatically generated.": "If enabled, client numbering will be automatically generated.",
  "Image must be smaller than 4MB!": "Image must be smaller than 4MB!",
  "Import": "Import",
  "Import errors": "Import errors",
  "Important": "Important",
  "Important Notes": "Important Notes",
  "In progress": "In progress",
  "In this case, you have three options": "In this case, you have three options",
  "Information": "Information",
  "Intracom VAT does not match the SIRET": "Intracom VAT does not match the SIRET",
  "Intracom VAT must be FR + 2-character key + 9-digit SIREN": "Intracom VAT must be FR + 2-character key + 9-digit SIREN",
  "Invalid format": "Invalid format",
  "Invalid intracom VAT key, please verify the number": "Invalid intracom VAT key, please verify the number",
  "Invalid SIRET check digit, please verify the number": "Invalid SIRET check digit, please verify the number",
  "invoice": "Invoice",
  "Invoice": "Invoice",
  "INVOICE": "INVOICE",
  "Invoice address": "Invoice address",
  "Invoice address details": "Invoice address details",
  "Invoice amount": "Invoice amount",
  "Invoice display name": "Invoice display name",
  "Invoice Eclx. Tax": "Invoice Eclx. Tax",
  "Invoice HT": "Invoice HT",
  "Invoice including VAT means that all items in the invoice will be listed with their prices including VAT": "Invoice including VAT means that all items in the invoice will be listed with their prices including VAT.",
  "Invoice nr": "Invoice nr",
  "Invoice TTC": "Invoice TTC",
  "Invoice VAT": "Invoice VAT",
  "invoices": "Invoice",
  "Invoices": "Invoices",
  "Invoices format": "Invoices format",
  "Invoices number": "Invoices number",
  "Invoices to be drawn": "Invoices to be drawn",
  "It can be requested in the event of a dispute": "It can be requested in the event of a dispute.",
  "It can be requested in the event of a dispute.": "It can be requested in the event of a dispute.",
  "Item": "Item",
  "Keep editing": "Keep editing",
  "Keywords #month/#MONTH/#YEAR allow to automatically integrate the date in the object of the invoices.": "Keywords #month/#MONTH/#YEAR allow to automatically integrate the date in the object of the invoices.",
  "Label": "Label",
  "Last doc. validated": "Last doc. validated",
  "late invoices": "late invoices",
  "Late payment penalty": "Late payment penalty",
  "Latest modified documents": "Latest modified documents",
  "Leave without saving": "Leave without saving",
  "Left": "Left",
  "Legal Category": "Legal Category",
  "Legal form": "Legal form",
  "Legal status": "Legal status",
  "Length of counterparts": "Length of counterparts",
  "Let's set up your workspace in just a few steps. We'll personalize NeoFact to fit your business needs.": "Let's set up your workspace in just a few steps. We'll personalize NeoFact to fit your business needs.",
  "Level 1": "Level 1",
  "Level 2": "Level 2",
  "Level 3": "Level 3",
  "Limited to 8 MB for attachments.": "Limited to 8 MB for attachments.",
  "Line": "Line",
  "Line break": "Line break",
  "Loading": "Loading",
  "Loading document lines...": "Loading document lines...",
  "Loading...": "Loading...",
  "Local sell counterpart": "Local sell counterpart",
  "Login": "Login",
  "Logo description": "Logo description",
  "Logo position": "Logo position",
  "Logout": "Logout",
  "MAIN": "MAIN",
  "Main account": "Main account",
  "Main Bank": "Main Bank",
  "Main currency": "Main currency",
  "Mandat": "Mandat",
  "mandatory for commercial invoices since 2013": "",
  "Mandats SEPA": "Mandats SEPA",
  "Max": "Max",
  "Maximum 2000 lines per file": "Maximum 2000 lines per file",
  "Maximum number of decimal places to display for quantities": "Maximum number of decimal places to display for quantities",
  "Mention and legal status": "Mention and legal status",
  "Message": "Message",
  "Min/Max entry date": "Min/Max entry date",
  "Missing information": "Missing information",
  "Mobile": "Mobile",
  "Mobile phone": "Mobile phone",
  "Mode de paiement": "Mode de paiement",
  "Model.xlsx": "Model.xlsx",
  "Mon. TTC": "Mon. TTC",
  "Mont. HT": "Mont. HT",
  "Montant HT": "Montant HT",
  "Montant TTC": "Montant TTC",
  "Month": "Month",
  "months_ago": "{{ diffMonthsAgo }} months ago",
  "Most used counterpart": "Most used counterpart",
  "N-1": "N-1",
  "Name": "Name",
  "NeoFact has improved the layout of its invoices! Your selected": "NeoFact has improved the layout of its invoices! Your selected",
  "New category": "New category",
  "New comment": "New comment",
  "New product": "New product / service",
  "Newrai support": "Newrai support",
  "Next": "Next",
  "NIC": "NIC",
  "NINEA": "NINEA",
  "NINEA must have 9 digits": "NINEA must have 9 digits",
  "no": "no",
  "No": "No",
  "No access": "No access",
  "No attachments": "No attachments",
  "No data available": "No data available",
  "No documents found": "No documents found",
  "No lines available": "No lines available",
  "Nº of documents": "Nº of documents",
  "Nº of payments": "Nº of payments",
  "No options": "No options",
  "No Options": "No Options",
  "No priority tasks": "No priority tasks",
  "None": "None",
  "None selected": "None selected",
  "Not sent": "Not sent",
  "Not Started": "Not Started",
  "Not validated": "Not validated",
  "Note": "Note",
  "Notes": "Notes",
  "Notes / Legal status": "Notes / Legal status",
  "Notes & Legal": "Notes & Legal",
  "Notes and comments": "Notes and comments",
  "now features a modern, professional design.": "now features a modern, professional design.",
  "nr_documents_selected_produce": "Are you sure that you want to produce {{ nrDocumentsSelectedProduce }} document(s)?",
  "Number": "Number",
  "Number of days": "Number of days",
  "Numeration": "Numeration",
  "Object": "Object",
  "Objet": "Objet",
  "Objet du document": "Objet du document",
  "Occurrences": "Occurrences",
  "Off": "Off",
  "Offer in progress": "Offer in progress",
  "OK": "OK",
  "On": "On",
  "On Validate should create a payment?": "On Validate should create a payment?",
  "Only validated documents are taken into account": "Only validated documents are taken into account",
  "Oops Page Not Found": "Oops Page Not Found",
  "Operation type": "Operation type",
  "Operation Type": "Operation Type",
  "Operational category": "Operational category",
  "Operations": "Operations",
  "OPS": "OPS",
  "Optional label for this attachment": "Optional label for this attachment",
  "options": "options",
  "order": "Order",
  "ORDER": "ORDER",
  "Orders": "Orders",
  "Orders format": "Orders format",
  "Orders number": "Orders number",
  "Original": "Original",
  "Original document preview": "Original document preview",
  "Other": "Other",
  "OTHER": "OTHER",
  "Other currencies": "Other currencies",
  "Other sell counterpart": "Other sell counterpart",
  "Outer": "Outer",
  "Outstanding clients": "Outstanding clients",
  "Package cost counterpart": "Package cost counterpart",
  "Page": "Page",
  "Page break": "Page break",
  "Page Not Found": "Page Not Found",
  "Paid": "Paid",
  "PAID": "PAID",
  "Paid document preview": "Paid document preview",
  "Paiement": "Paiement",
  "Paiements": "Paiements",
  "PARTICULAR": "Particular",
  "Pay day": "Pay day",
  "Payment": "Payment",
  "Payment confirmation": "Payment confirmation",
  "Payment Date": "Payment Date",
  "Payment date limit": "Payment date limit",
  "Payment Date Limit": "Payment Date Limit",
  "Payment deadline": "Payment deadline",
  "Payment Deadline": "Payment Deadline",
  "Payment deadline method": "Payment deadline method",
  "Payment in advance": "Payment in advance",
  "Payment in advance format": "Payment in advance format",
  "Payment in advance number": "Payment in advance number",
  "Payment limit": "Payment limit",
  "Payment method": "Payment method",
  "Payment Method": "Payment Method",
  "Payment methods": "Payment methods",
  "Payment period": "Payment period",
  "Payment settings": "Payment settings",
  "Payment transactions": "Payment transactions",
  "payment_in_advance": "Payment in advance",
  "paymentInAdvance": "Payment in advance",
  "Payments": "Payments",
  "Payments in advance": "Payments in advance",
  "Payments received": "Payments received",
  "Percentage": "Percentage",
  "Period": "Period",
  "Periodic": "Periodic",
  "Periodic billing": "Periodic billing",
  "Periodicals": "Periodicals",
  "Periods": "Periods",
  "Phone": "Phone",
  "Phone number": "Phone number",
  "Phone Numbers": "Phone Numbers",
  "Phones & emails": "Phones & emails",
  "Please check the form for errors": "Please check the form for errors",
  "Please choose a product": "Please choose a product / service",
  "Please create a currency before proceeding": "Please create a currency before proceeding",
  "Please enter a valid email": "Please enter a valid email",
  "Please enter valid email addresses.": "Please enter valid email addresses.",
  "Please select a company before starting to use the application": "Please select a company before starting to use the application",
  "Please select a company to view company data": "Please select a company to view company data.",
  "Please select or set a main currency.": "Please select or set a main currency.",
  "Please upload a file": "Please upload a file",
  "Please wait, documents are downloading": "Please wait, documents are downloading",
  "Please write more than 3 numbers": "Please write more than 3 numbers",
  "Please write more than 4 characters": "Please write more than 4 characters",
  "Portuguese": "Portuguese",
  "Position": "Position",
  "Postal code": "Postal code",
  "Postal Code": "Postal Code",
  "Postcode": "Postcode",
  "Preferences": "Preferences",
  "Prefix": "Prefix",
  "Prefix client counterpart code": "Prefix client counterpart code",
  "Prefix provider counterpart code": "Prefix provider counterpart code",
  "Preview": "Preview",
  "Preview your new template below and see how it enhances your business documents.": "Preview your new template below and see how it enhances your business documents.",
  "Price": "Price",
  "Price HT": "Price HT",
  "Price TTC": "Price TTC",
  "Prices by currency": "Prices by currency",
  "Pricing information": "Pricing information",
  "Priority tasks": "Priority tasks",
  "Prix unitaire TTC": "Prix unitaire TTC",
  "Produce": "Produce",
  "Produce document": "Produce document",
  "Produce documents": "Produce documents",
  "produce_total_documents": "Are you sure that you want to produce {{ totalDocuments }} document(s)?",
  "Produced": "Produced",
  "PRODUCED": "produced",
  "Product": "Product",
  "Product count": "Product count",
  "Product families (product types) must exist before importing products - create or import them first": "Product families (product types) must exist before importing products - create or import them first",
  "Product name on line": "Product name on line",
  "Product price": "Product price",
  "Product type": "Product type",
  "Production before tax per user": "Production before tax per user",
  "Products": "Products",
  "Products / Services": "Products / Services",
  "proforma": "Proforma",
  "Proforma": "Proforma",
  "Provider": "Provider",
  "PU HT": "PU HT",
  "PU TTC": "PU TTC",
  "PUBLIC_ADMINISTRATION": "Public Administration",
  "Purchase Order": "Purchase Order",
  "Purchase price": "Purchase price",
  "PURCHASE_ORDER": "Invoice",
  "Qté": "Qté",
  "Qty": "Qty",
  "Quantity": "Quantity",
  "Quantity Tracking": "Quantity Tracking",
  "Quantity Tracking2": "Quantity Tracking2",
  "Quote pending": "Quote pending",
  "Rate": "Rate",
  "RCS": "RCS",
  "Reactivate": "Reactivate",
  "Reactivate payment date limit": "Reactivate payment date limit",
  "Reactivate product": "Reactivate product / service",
  "receipt": "receipt",
  "Receipt": "Receipt",
  "Receipt format": "Receipt format",
  "Receipt number": "Receipt number",
  "Receipts": "Receipts",
  "Receipts for the year": "Receipts for the year",
  "Received": "Received",
  "Received and readed": "Received and readed",
  "Receivers": "Receivers",
  "Recipients": "Recipients",
  "Recommendation": "Recommendation",
  "Reconciliation": "Reconciliation",
  "Recurrent": "Recurrent",
  "Reexport": "Reexport",
  "Ref": "Ref",
  "Reference": "Reference",
  "Référence": "Référence",
  "Reference | Ref": "Reference | Ref",
  "Référence unique de Mandat (RUM)": "Référence unique de Mandat (RUM)",
  "References": "References",
  "Refresh": "Refresh",
  "Refresh page": "Refresh page",
  "Refuse": "Refuse",
  "Refuse document": "Refuse document",
  "Refused": "Refused",
  "REFUSED": "refused",
  "Refused successfully": "Refused successfully",
  "Refuser": "Refuser",
  "Registered": "Registered",
  "Regulations": "Regulations",
  "Reject/Cancel remaining payments": "Reject/Cancel remaining payments",
  "Rejected": "Rejected",
  "Rem": "Rem",
  "Reminder for group documents": "Reminder for group documents",
  "Remove from selection": "Remove from selection",
  "Required": "Required",
  "Reset": "Reset",
  "Reset filters": "Reset filters",
  "Reset to default": "Reset to default",
  "Resume periodic payment": "Resume periodic payment",
  "Retransfer of a bulk to SSI": "Retransfer of a bulk to SSI",
  "return": "Return",
  "Return": "Return",
  "RETURN": "Return",
  "Return number": "Return number",
  "Returns": "Returns",
  "RETURNS": "RETURNS",
  "Revenue for the year": "Revenue for the year",
  "Revenues": "Revenues",
  "Right": "Right",
  "Roll Back made with success": "Roll Back made with success.",
  "Row": "Row",
  "RUM": "RUM",
  "Sale account": "Sale account",
  "Sale order": "Sale order",
  "Sale Order": "Sale Order",
  "Sale vat": "Sale vat",
  "sale_order": "Sale order",
  "SALE_ORDER": "Sale order",
  "Sales": "Sales",
  "Sales accounts": "Sales accounts",
  "Sales VAT": "Sales VAT",
  "Save": "Save",
  "Save & Go next": "Save & Go next",
  "Save & Next": "Save & Next",
  "Save & Preview": "Save & Preview",
  "Save and preview document": "Save and preview document",
  "Save short": "Save",
  "Saved comments": "Saved comments",
  "Saved Successfully": "Saved Successfully",
  "Search": "Search",
  "Search by reference": "Search by reference",
  "Search for an existing client": "Search for an existing client",
  "Search in my invoices": "Search in my invoices",
  "Search or create ...": "Search or create ...",
  "See all": "See all",
  "See all documents": "See all documents",
  "Select": "Select",
  "Select a file": "Select a file",
  "Select a font": "Select a font",
  "Select accounting firm": "Select accounting firm",
  "Select address": "Select address",
  "Select all {{count}} documents_one": "Select all {{count}} documents",
  "Select all {{count}} documents_other": "Select all {{count}} documents",
  "Select an option": "Select an option",
  "Select Book": "Select Book",
  "Select business activity": "Select business activity",
  "Select category": "Select category",
  "Select city": "Select city",
  "Select client": "Select client",
  "Select company": "Select company",
  "Select Company": "Select Company",
  "Select counterpart": "Select counterpart",
  "Select country": "Select country",
  "Select default counterpart": "Select default counterpart",
  "Select invoice": "Select invoice",
  "Select legal structure": "Select legal structure",
  "Select period": "Select period",
  "Select postal code": "Select postal code",
  "Select product type": "Select product / service type",
  "Select sell book": "Select sell book",
  "Select type": "Select type",
  "Select unit": "Select unit",
  "Select vat": "Select vat",
  "Select VAT": "Select VAT",
  "select_all_rows_prefix": "Select all",
  "select_all_rows_suffix": "rows in the table.",
  "Sell book": "Sell book",
  "Send": "Send",
  "Send back to neoscan expert": "Send back to neoscan expert",
  "Send back to SSI": "Send back to SSI",
  "Send by email": "Send by email",
  "Send email": "Send email",
  "Send me a copy of the email": "Send me a copy of the email",
  "Send overdue email": "Send overdue email",
  "Send reminder": "Send reminder",
  "Send reminderrrrrrr": "Send reminderrrrrrr",
  "Sent": "Sent",
  "Sent to": "Sent to",
  "SEPA Credential Identifier": "SEPA Credential Identifier",
  "SEPA identifier is missing": "SEPA identifier is missing",
  "SEPA Mandats": "SEPA Mandats",
  "Sepa order": "Sepa order",
  "Sequence": "Sequence",
  "Service": "Service",
  "Set date to today": "Set date to today",
  "Set to": "Set to",
  "Settings": "Settings",
  "Setup Accountings": "Setup Accountings",
  "Setup company": "Setup company",
  "Setup Features": "Setup Features",
  "Setup formats": "Setup formats",
  "Setup Payments": "Setup Payments",
  "Setup Vats": "Setup Vats",
  "Short Name": "Short Name",
  "Show exported documents": "Show exported documents",
  "Show phones & emails": "Show phones & emails",
  "Sign": "Sign",
  "Signé le": "Signé le",
  "Signed": "Signed",
  "Signed mandate in PDF format you can attach the mandate signed by your client to to keep it": {
    " ": "Signed mandate in PDF format you can attach the mandate signed by your client to to keep it. "
  },
  "Signed mandate in PDF format You can attach the mandate signed by your client to to keep it": {
    " ": "Signed mandate in PDF format You can attach the mandate signed by your client to to keep it. "
  },
  "Signed mandate in PDF format you can attach the mandate signed by your client to to keep it. ": "Signed mandate in PDF format you can attach the mandate signed by your client to to keep it. ",
  "Signed mandate in PDF format you can attach the mandate signed by your client to to keep it. It can be requested in the event of a dispute.": "Signed mandate in PDF format you can attach the mandate signed by your client to to keep it. It can be requested in the event of a dispute.",
  "Single line": "Single line",
  "Siren": "Siren",
  "Siren must have 9 digits": "Siren must have 9 digits",
  "Siret": "Siret",
  "SIRET": "SIRET",
  "SIRET must have 9 digits (SIREN) or 14 digits (SIRET), {{length}} entered": "SIRET must have 9 digits (SIREN) or 14 digits (SIRET), {{length}} entered",
  "Size": "Size",
  "Software": "Software",
  "Some relationship wasn't successfully connected": "Some relationship wasn't successfully connected",
  "Something went wrong on deleting": "Something went wrong on deleting",
  "Sorry, the page you're trying to access does not exist.": "Sorry, the page you're trying to access does not exist.",
  "Source": "Source",
  "Spanish": "Spanish",
  "SSI type": "SSI type",
  "SSI Type": "SSI Type",
  "Stamp section": "Stamp section",
  "Stamp Space": "Stamp Space",
  "Start": "Start",
  "Start date": "Start date",
  "Start day": "Start day",
  "State": "State",
  "status": "status",
  "Status": "Status",
  "Step {{current}} of {{total}}": "Step {{current}} of {{total}}",
  "Stop billing": "Stop billing",
  "Stop billing ": "Stop billing ",
  "Sub-total": "Sub-total",
  "Subject of the invoice": "Subject of the invoice",
  "Submit": "Submit",
  "Submited by": "Submited by",
  "Subsidiary": "Subsidiary",
  "Subtotal": "Subtotal",
  "Successfully": "Successfully",
  "Successfully created": "Successfully created",
  "Successfully imported": "Successfully imported",
  "Successfully sent": "Successfully sent",
  "Successfully transferred": "Successfully transferred",
  "Suggested (SIREN)": "Suggested (SIREN)",
  "Sum of all items above": "Sum of all items above",
  "Summary": "Summary",
  "Table borders": "Table borders",
  "Table header color": "Table header color",
  "Tax rates": "Tax rates",
  "Telephone": "Telephone",
  "Template": "Template",
  "Template 1": "Template 1",
  "Template 2": "Template 2",
  "Template 3": "Template 3",
  "Template 4": "Template 4",
  "Template language": "Template language",
  "Template Preview": "Template Preview",
  "Template watermark": "Template watermark",
  "Terms of validity": "Terms of validity",
  "Text": "Text",
  "Text background": "Text background",
  "Text Color": "Text Color",
  "Text color with background": "Text color with background",
  "Thank you": "Thank you",
  "Thank you for taking the time to set up your configuration.": "Thank you for taking the time to set up your configuration.",
  "The After validation mode gives you the possibility to visualize the content of the invoice before generation for a possible adjustment.": "The After validation mode gives you the possibility to visualize the content of the invoice before generation for a possible adjustment.",
  "The amount cannot exceed {{percentage}}% or {{value}}": "The amount cannot exceed {{percentage}}% or {{value}}",
  "The Automatic mode allows you to automatically send your invoices to customers.": "The Automatic mode allows you to automatically send your invoices to customers.",
  "The day is invalid for the month": "The day is invalid for the month",
  "The document of type": "The document of type",
  "The field in the line had an error and was ignored": "The field in the line had an error and was ignored",
  "The file must be in .xlsx, .xls, or .csv format": "The file must be in .xlsx, .xls, or .csv format",
  "The file must not contain more than 2000 lines": "The file must not contain more than 2000 lines",
  "The invoice number must be unique, based on a chronological and continuous sequence.": "The invoice number must be unique, based on a chronological and continuous sequence.",
  "The line could not be imported": "The line could not be imported",
  "The number of characters limit is 14": "The number of characters limit is 14",
  "The number of occurrences to automatically stop the generation at the deadline. The generation can also be stopped at any time via the Numbers menu.": "The number of occurrences to automatically stop the generation at the deadline. The generation can also be stopped at any time via the Numbers menu.",
  "The page you are looking for does not exist or has been moved": "The page you are looking for does not exist or has been moved.",
  "The selected date on the document is earlier than the most recently validated document, please update the date.": "The selected date on the document is earlier than the most recently validated document, please update the date.",
  "The tax authorities require that the invoice number be unique, based on a chronological and continuous sequence": "The tax authorities require that the invoice number be unique, based on a chronological and continuous sequence.",
  "The tax authorities require that the invoice number be unique, based on a chronological and continuous sequence.": "The tax authorities require that the invoice number be unique, based on a chronological and continuous sequence.",
  "The unique mandate reference must be unique in order to generate your direct debit files SEPA": "The unique mandate reference must be unique in order to generate your direct debit files SEPA",
  "There are no documents to export": "There are no documents to export",
  "There must be 2 or 4 A's": "There must be 2 or 4 A's",
  "There was an error try again later or contact your support": "There was an error try again later or contact your support",
  "These settings are for preview purposes only": "These settings are for preview purposes only",
  "Third parties accounts length": "Third parties accounts length",
  "This counterpart does not exist": "This counterpart does not exist",
  "This field is required": "This field is required",
  "This field only accept numbers": "This field only accept numbers",
  "This guide shows you the available columns and their valid options for importing client information. Make sure your file matches these specifications.": "This guide shows you the available columns and their valid options for importing client information. Make sure your file matches these specifications.",
  "This invoice was generated using": "This invoice was generated using",
  "This is a description.": "This is a description.",
  "This is a description. This is a description.": "This is a description. This is a description.",
  "This is how your invoices will look with the new template": "This is how your invoices will look with the new template",
  "This note will appear or auto-fill the note field when creating invoices": "This note will appear or auto-fill the note field when creating invoices",
  "This note will auto-fill the note field when creating invoices": "This note will auto-fill the note field when creating invoices",
  "This option allows you to choose the default billing mode for all your future documents Invoice including VAT means that all items in the invoice will be listed with their prices including VAT": "This option allows you to choose the default billing mode for all your future documents Invoice including VAT means that all items in the invoice will be listed with their prices including VAT",
  "This option allows you to choose the default billing mode for all your future documents. Invoice including VAT means that all items in the invoice will be listed with their prices including VAT.": "This option allows you to choose the default billing mode for all your future documents. Invoice including VAT means that all items in the invoice will be listed with their prices including VAT.",
  "Tip": "Tip",
  "Title": "Title",
  "to": "to",
  "To be collected": "To be collected",
  "To customize your template, navigate to": "To customize your template, navigate to",
  "To enable direct debits": "To enable direct debits",
  "To export": "To export",
  "To_be_paid": "To be paid",
  "Today": "Today",
  "Top customers (turnover excluding tax)": "Top customers (turnover excluding tax)",
  "Total": "Total",
  "Total Balance": "Total Balance",
  "Total days": "Total days",
  "Total Documents": "Total Documents",
  "Total in debt": "Total in debt",
  "Total Invoices": "Total Invoices",
  "Total pages": "Total pages",
  "Total Payments": "Total Payments",
  "Total Returns": "Total Returns",
  "Total table items": "Total {{count}} items",
  "Total table items_many": "Total {{count}} items",
  "Total table items_one": "Total {{count}} item",
  "Total table items_other": "Total {{count}} items",
  "Total table items_plural": "Total {{count}} items",
  "Total TE": "Total TE",
  "Total TTC": "Total TTC",
  "total_rows_selected_prefix": "All",
  "total_rows_selected_suffix": "rows in this table are selected.",
  "Tranfers": "Tranfers",
  "Transfer to accounts": "Transfer to accounts",
  "TTC": "TTC",
  "TTC : This option will allow you to invoice in TTC. The price in the Products file will be given in VAT. The software will recalculate the price before tax according to the VAT rate.": "TTC : This option will allow you to invoice in TTC. The price in the Products file will be given in VAT. The software will recalculate the price before tax according to the VAT rate.",
  "Turnover before tax": "Turnover before tax",
  "Turnover before tax for the top 30 customers": "Turnover before tax for the top 30 customers",
  "Turnover in before tax": "Turnover before tax",
  "Tva": "Tva",
  "TVA": "TVA",
  "TVA Intracom": "TVA Intracom.",
  "TVA Intracom.": "TVA Intracom.",
  "TVA Type": "TVA Type",
  "Type": "Type",
  "Type de prélèvement": "Type de prélèvement",
  "Type de TVA": "Type de TVA",
  "Type of sampling": "Type of sampling",
  "Unexpected error": "Unexpected error",
  "Unique mandate reference (RUM)": "Unique mandate reference (RUM)",
  "Unit": "Unit",
  "Unit measure": "Unit measure",
  "Unit measures": "Unit measures",
  "Unit of measure": "Unit of measure",
  "Unit of measure codes must match existing units (u, kg, l, h, m, etc.)": "Unit of measure codes must match existing units (u, kg, l, h, m, etc.)",
  "Unit price": "Unit price",
  "Unit price before tax": "Unit price before tax",
  "Unit price incl": {
    " VAT": "Unit price incl. VAT"
  },
  "Unit price including tax": "Unit price including tax",
  "Unit price including VAT": "Unit price including VAT",
  "Units of measure": "Units of measure",
  "Unsaved changes": "Unsaved changes",
  "Update": "Update",
  "Update account": "Update account",
  "Update address": "Update address",
  "Update contact": "Update contact",
  "update date for today": "update date for today",
  "Update date for today": "Update date for today",
  "Update export configuration": "Update export configuration",
  "Update payment": "Update payment",
  "Update payment date": "Update payment date",
  "Update periodic billing": "Update periodic billing",
  "Update product": "Update product / service",
  "Update sale account": "Update sale account",
  "Update sale vat": "Update sale vat",
  "Update sepa order": "Update sepa order",
  "Update template": "Update template",
  "Update VAT": "Update VAT",
  "Update vat type": "Update vat type",
  "Updated successfully": "Updated successfully",
  "Upload": "Upload",
  "Upload files that will be automatically attached to emails. Use the checkboxes to select which document types include each attachment.": "Upload files that will be automatically attached to emails. Use the checkboxes to select which document types include each attachment.",
  "Uploaded file": "Uploaded file",
  "Uploaded to Interops": "Uploaded to Interops",
  "Use the example": "",
  "Valid Date": "Valid Date",
  "Valid until": "Valid until",
  "Validate": "Validate",
  "Validate document": "Validate document",
  "validate documents": "Validate documents",
  "Validate payment": "Validate payment",
  "validate_total_documents": "Are you sure that you want to validate {{ totalDocuments }} document(s)?",
  "Validated": "Validated",
  "VALIDATED": "validated",
  "Validated Successfully": "Validated Successfully",
  "Validity date": "Validity date",
  "Value": "Value",
  "Vat": "Vat",
  "VAT": "VAT",
  "VAT account": "VAT account",
  "VAT at": "VAT at",
  "VAT Intracom": "VAT Intracom",
  "Vat number": "Vat number",
  "Vat Number": "Vat Number",
  "VAT Number": "VAT Number",
  "VAT rate": "VAT rate",
  "Vat type": "Vat type",
  "VAT Type": "VAT Type",
  "Vats": "Vats",
  "View": "View",
  "View all": "View all",
  "View receipt": "View receipt",
  "Volume": "Volume",
  "Watermark opacity": "Watermark opacity",
  "We appreciate your commitment to personalizing your experience and hope that you find our site to be an enjoyable and valuable resource. Should you have any questions or encounter any difficulties during the setup process, our dedicated support team is always here to assist you.": "We appreciate your commitment to personalizing your experience and hope that you find our site to be an enjoyable and valuable resource. Should you have any questions or encounter any difficulties during the setup process, our dedicated support team is always here to assist you.",
  "We are thrilled to have you here. Before we delve into the exciting content and features of our site, we would like to highlight the importance of setting up the configuration to ensure you have the best possible user experience.": "We are thrilled to have you here. Before we delve into the exciting content and features of our site, we would like to highlight the importance of setting up the configuration to ensure you have the best possible user experience.",
  "We recommend that you avoid numbering containing sequence breaks such as AAMMXXXX": "We recommend that you avoid numbering containing sequence breaks such as AAMMXXXX.",
  "We recommend that you avoid numbering containing sequence breaks such as AAMMXXXX.": "We recommend that you avoid numbering containing sequence breaks such as AAMMXXXX.",
  "We're excited to have you join us! Let's take a moment to set up your configuration for the best possible experience. This quick process will help personalize NeoFact to your needs.": "We're excited to have you join us! Let's take a moment to set up your configuration for the best possible experience. This quick process will help personalize NeoFact to your needs.",
  "Welcome": "Welcome",
  "welcome page": "welcome page",
  "Welcome to NeoFact": "Welcome to NeoFact",
  "What we'll set up": "What we'll set up",
  "when using this mandate for the first time": "when using this mandate for the first time",
  "when you are going to make the last withdrawal to close the mandate": "when you are going to make the last withdrawal to close the mandate",
  "when you have already made direct debits with this mandate": "when you have already made direct debits with this mandate",
  "Who is the receiver?": "Who is the receiver?",
  "with an amount of": "with an amount of",
  "Work": "Work",
  "Year": "Year",
  "yes": "yes",
  "Yes": "Yes",
  "You are logged out": "You are logged out",
  "You can only attach up to {{count}} files._one": "You can only attach up to {{count}} file.",
  "You can only attach up to {{count}} files._other": "You can only attach up to {{count}} files.",
  "You can only upload JPG/PNG file!": "You can only upload JPG/PNG file!",
  "You can use the strings AA or AAAA for the year, MM for the month, X for the marking pattern and N for the invoice number": "You can use the strings AA or AAAA for the year, MM for the month, X for the marking pattern and N for the invoice number.",
  "You can use the strings AA or AAAA for the year, MM for the month, X for the marking pattern and N for the invoice number.": "You can use the strings AA or AAAA for the year, MM for the month, X for the marking pattern and N for the invoice number.",
  "You can use the strings AA or AAAA for year, MM for month and X for dialing pattern.": "You can use the strings AA or AAAA for year, MM for month and X for dialing pattern.",
  "You can use the strings AA or AAAA for year, MM for month and X for dialling pattern": "You can use the strings AA or AAAA for year, MM for month and X for dialling pattern.",
  "You can't produce the documents below, because the date is before the last valid date.": "You can't produce the documents below, because the date is before the last valid date.",
  "you can't validate the documents below, because the date is before the last valid date.": "you can't validate the documents below, because the date is before the last valid date.",
  "You cannot change the export configuration because there are validated documents.": "You cannot change the export configuration because there are validated documents.",
  "You do not have access to this application": "You do not have access to this application",
  "You have unsaved changes in the main form. Save or discard them before editing this section.": "You have unsaved changes in the main form. Save or discard them before editing this section.",
  "You have unsaved changes. Do you want to save before leaving?": "You have unsaved changes. Do you want to save before leaving?",
  "You're all set!": "You're all set!",
  "Your mandate is either defined for a one-off direct debit (Punctual) or for a recurring direct debit": {
    " ": "Your mandate is either defined for a one-off direct debit (Punctual) or for a recurring direct debit. "
  },
  "Your mandate is either defined for a one-off direct debit (Punctual) or for a recurring direct debit. ": "Your mandate is either defined for a one-off direct debit (Punctual) or for a recurring direct debit. ",
  "Your workspace is configured and ready to go. Start exploring your dashboard.": "Your workspace is configured and ready to go. Start exploring your dashboard.",
  "This document": "This document",
  "Last validated invoice": "Last validated invoice",
  "Date is earlier than the last validated invoice": "Date is earlier than the last validated invoice",
  "New date:": "New date:",
  "Allowed dates": "Allowed dates",
  "Other date": "Other date",
  "Your changes could not be saved": "Your changes could not be saved",
  "Duplicate the last saved version instead? Your unsaved changes will not be copied.": "Duplicate the last saved version instead? Your unsaved changes will not be copied."
}
